module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/clock.svg?f3c12df04c71df395464e88e5a1e9cf3";